import Api from "../../../Services/Api";
import {flattenFormGroupObject, getValueFromDDL} from "../../common/mapper";
import {ACTIVITY_TYPE, GenericSequenceType, HttpStatus} from "../../common/Constants";
import * as R from "ramda";
import {fetchDataAsync} from "../../../Services/Utils";

// to check if string is empty or null
const isNullOrEmpty = R.either(R.isNil, R.isEmpty);

// TO DO: fetch data detail stock opname
export const fetchDataDetailStockOpname = async (isProcess, setState, type, queryParam, setError) => {
    let valueType = Object.keys(type).length > 0 ? type?.value : null;
    switch (valueType) {
        case "UNIT":
            return await fetchDataDetailStockOpnameUnit(isProcess, setState, queryParam, setError);

        case "PART":
            return await fetchDataDetailStockOpnamePart(isProcess, setState, queryParam, setError);

        case "KSU":
            return await fetchDataDetailStockOpnameKSU(isProcess, setState, queryParam, setError);
            
        case "GIFT":
            return await fetchDataDetailStockOpnameGIFT(isProcess, setState, queryParam, setError);
            
        case "OTHER_ITEM":
            return await fetchDataDetailStockOpnameOtherItems(isProcess, setState, queryParam, setError)
        
        default:
            break;
    }
}

const fetchDataDetailStockOpnameUnit = async (isProcess, setState, queryParam, setError) => {
    let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailStockOpnameUnit,
        menuName: "Stock Opname",
        setError: setError,
        args: queryParam,
    });
    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
        setState((prevValue) => ({
            ...prevValue,
            dataTable: isProcess ?
                response.data.data?.dataUnit.filter((item) => item?.unitExist === false) :
                response.data.data?.dataUnit,
            dataForSubmitted: response.data.data?.dataUnit,
            totalProcess: {
                ...prevValue.totalProcess,
                totalItem: response.data.data?.dataUnit.length,
                totalScanned: response.data.data?.dataUnit.filter((item) => item?.unitExist === true).length,
                totalUnScanned: response.data.data?.dataUnit.filter((item) => item?.unitExist === false).length
            },
            dataChecked: [...new Set(response.data.data?.checkedTypes)],
        }));
    }
}

const fetchDataDetailStockOpnameKSU = async (isProcess, setState, queryParam, setError) => {
    let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailStockOpnameKSU,
        menuName: "Stock Opname",
        setError: setError,
        args: queryParam,
    });
    if (response.ok && response.data?.status === HttpStatus.SUCCESS) {
        setState((prevValue) => ({
            ...prevValue,
            dataTable: isProcess
                ? response.data?.data?.filter((item) => item?.ksuExist === false)
                : response.data?.data,
            dataForSubmitted: response.data?.data,
            totalProcess: {
                ...prevValue.totalProcess,
                totalItem: response.data?.data?.length,
                totalScanned: response.data?.data?.filter((item) => item?.ksuExist === true).length,
                totalUnScanned: response.data?.data?.filter((item) => item?.ksuExist === false).length
            },
            dataChecked: [...new Set(response.data?.data?.map(item => item?.kodeKSU))]
        }));
    }
}

export const constructDataQrGift = (data) => {
  return {
    ...data,
    namaHadiah: data?.giftCode.nameHadiah,
    kodeHadiah: data?.giftCode.kodeHadiah,
    categoryHadiah: data?.giftCode.categoryDTO.value,
    satuan: data?.giftCode.satuanDTO?.value,
    satuanKey: data?.giftCode.satuanDTO?.key,
    giftBarcode: data?.giftBarcode,
    barcodeEncrypted: data?.barcodeEncrypted,
  };
};

const constructDataNonQrGift = (data) => {
  return {
    ...data,
    actQTY: data?.actualQty,
    diffQty: data?.diffQty,
    keterangan: data?.note,
    namaHadiah: data?.giftCode?.nameHadiah,
    kodeHadiah: data?.giftCode?.kodeHadiah,
    satuan: data?.giftCode?.satuanDTO?.value,
    satuanKey: data?.giftCode?.satuanHadiah,
    categoryHadiah: data?.giftCode?.categoryDTO.value,
    isSaved: true,
  };
};

export const constructDataQrPart = (item) => {
  return {
    ...item,
    partBarcode: item?.partBarcode,
    partExist: item?.partExist,
    kodePart: item?.partCode?.kodePart || "",
    partName: item?.partCode?.partName || "",
    category: item?.partCode?.partCategory?.value || "",
    satuan: item?.partCode?.satuan?.value || "",
    barcodeEncrypted: item?.barcodeEncrypted,
  };
};

const constructDataNonQrPart = (item) => {
  return {
    ...item,
    qty: item?.qty,
    actualQty: item?.actualQty,
    diffQty: item?.diffQty,
    kodePart: item?.partCode?.kodePart || "",
    partName: item?.partCode?.partName || "",
    category: item?.partCode?.partCategory?.value || "",
    satuan: item?.partCode?.satuan?.value || "",
    isSaved: true,
  };
};

export const constructDataQrOtherItem = (item) => {
  return {
    ...item,
    namaOtherItem: item?.dataOtherItem?.nameotheritem,
    kodeOtherItem: item?.dataOtherItem?.kodeotheritem,
    categoryotheritem: item?.dataOtherItem?.categoryDTO.value,
    satuan: item?.dataOtherItem?.satuanDTO?.value,
    satuanKey: item?.dataOtherItem?.satuanDTO?.key,
    barcode: item?.barcode,
    barcodeEncrypted: item?.barcodeEncrypted,
    qty: item?.dataOtherItem?.qty || 0,
  };
};

export const constructDataNonQrOtherItem = (item) => {
  return {
    ...item,
    actQTY: item?.actualQty,
    diffQty: item?.diffQty,
    keterangan: null,
    namaOtherItem: item?.dataOtherItem?.nameotheritem,
    kodeOtherItem: item?.dataOtherItem?.kodeotheritem,
    satuan: item?.dataOtherItem?.satuanDTO?.value,
    satuanKey: item?.dataOtherItem?.satuanDTO?.key,
    categoryotheritem: item?.dataOtherItem?.categoryDTO.value,
    isSaved: true,
  };
};

const fetchDataDetailStockOpnameGIFT = async (isProcess, setState, queryParam, setError) => {
    let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").getStockOpnameGiftDetail,
        menuName: "Stock Opname",
        setError: setError,
        args: queryParam,
    });
    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
        const dataQr = isProcess
                ? response.data?.data?.listQr.filter((item) => item.giftExist === false)
                : response.data?.data?.listQr;
        setState((prevValue) => ({
          ...prevValue,
          dataTable: dataQr.map((item) => constructDataQrGift(item)),
          dataTableNonQr: response.data?.data?.listNonQr.map((item) =>
            constructDataNonQrGift(item)
          ),
          dataForSubmitted: {
            nonQr: response.data?.data?.listNonQr.map((item) =>
              // constructDataNonQrGift(item)
            constructDataNonQrGift({
              ...item,
              userId: item?.userId?.idUser ?? item?.userId ?? null,
            })
            ),
            qr: response.data?.data?.listQr.map((item) =>
              constructDataQrGift(item)
            ),
          },
          totalProcess: {
            totalItem: response.data?.data?.listQr.length,
            totalScanned: response.data?.data?.listQr.filter(
              (item) => item?.giftExist === true
            ).length,
            totalUnScanned: response.data?.data?.listQr.filter(
              (item) => item?.giftExist === false
            ).length,
          },
          totalProcessNonQr: {
              totalItem: response.data.data?.listNonQr?.length,
              totalUnScanned: 0,
              totalScanned: response.data.data?.listNonQr?.length,
          },
          rawDetailData: response.data.data,
          // dataChecked: [...new Set(response.data.data?.map(item => item.kodeKSU))]
        }));
    }
}

const fetchDataDetailStockOpnameOtherItems = async (isProcess, setState, queryParam, setError) => {
    let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").getStockOpnameOtherItemDetail,
        menuName: "Stock Opname",
        setError: setError,
        args: queryParam,
    });
    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
      const dataQr = isProcess
        ? response.data?.data?.dataOtherItemBarcode.filter(
            (item) => item?.exist === false
          )
        : response.data?.data?.dataOtherItemBarcode;
      setState((prevValue) => ({
        ...prevValue,
        dataTable: dataQr.map((item) => constructDataQrOtherItem(item)),
        dataTableNonQr: response.data?.data?.dataOtherItem?.map((item) =>
          constructDataNonQrOtherItem(item)
        ),
        dataForSubmitted: {
          nonQr: response.data?.data?.dataOtherItem?.map((item) =>
            // constructDataNonQrOtherItem(item)
          constructDataNonQrOtherItem({
            ...item,
            userId: item?.userId?.idUser ?? item?.userId ?? null,
          })
          ),
          qr: response.data?.data?.dataOtherItemBarcode?.map((item) =>
            constructDataQrOtherItem(item)
          ),
        },
        totalProcess: {
          totalItem: response.data?.data?.dataOtherItemBarcode.length,
          totalScanned: response.data?.data?.dataOtherItemBarcode?.filter(
            (item) => item.exist === true
          ).length,
          totalUnScanned: response.data?.data?.dataOtherItemBarcode?.filter(
            (item) => item.exist === false
          ).length,
        },
        totalProcessNonQr: {
          totalItem: response.data?.data?.dataOtherItem?.length,
          totalUnScanned: response.data?.data?.dataOtherItem?.length,
          totalScanned: 0,
        },
        rawDetailData: response.data?.data,
        // dataChecked: [...new Set(response.data.data?.map(item => item.kodeKSU))]
      }));
    }
}

const fetchDataDetailStockOpnamePart = async (isProcess, setState, queryParam, setError) => {
    let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailStockOpnamePart,
        menuName: "Stock Opname",
        setError: setError,
        args: queryParam,
    });
    
    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
        const dataQr = isProcess
                ? response.data?.data?.partQrList?.filter((item) => item.partExist === false)
                : response.data?.data?.partQrList;
        
        setState((prevValue) => ({
          ...prevValue,
          dataTable: dataQr.map((item) => constructDataQrPart(item)),
          dataTableNonQr: response.data?.data?.partNonQrList?.map((item) =>
            constructDataNonQrPart(item)
          ),
          dataForSubmitted: {
            nonQr: response.data?.data?.partNonQrList?.map((item) =>
              // constructDataNonQrPart(item)
            constructDataNonQrPart({
              ...item,
              userId: item?.userId?.idUser ?? item?.userId ?? null,
            })
            ),
            qr: response.data?.data?.partQrList?.map((item) =>
              constructDataQrPart(item)
            ),
          },
          totalProcess: {
            totalItem: response.data?.data?.partQrList?.length,
            totalScanned: response.data?.data?.partQrList?.filter(
              (item) => item?.partExist === true
            ).length,
            totalUnScanned: response.data?.data?.partQrList?.filter(
              (item) => item?.partExist === false
            ).length,
          },
          totalProcessNonQr: {
              totalItem: response.data.data?.partNonQrList?.length,
              totalUnScanned: 0,
              totalScanned: response.data.data?.partNonQrList?.length,
          },
          rawDetailData: response.data.data,
          // dataChecked: [...new Set(response.data.data?.map(item => item.kodeKSU))]
        }));
    }
}

// TO DO: submit add data detail stock opname
export const fetchSubmitAddDataDetailStockOpname = async (setState, type, body, setError, rawDetailData, activityType) => {
    let valueType = Object.keys(type).length > 0 ? type.value : null;
    switch (valueType) {
        case "UNIT":
            return await fetchSubmitAddDataDetailStockOpnameUnit(setState, body, setError);

        case "PART":
            return await fetchSubmitAddDataDetailStockOpnamePart(setState, body, setError, rawDetailData, activityType);

        case "KSU":
            return await fetchSubmitAddDataDetailStockOpnameKSU(setState, body, setError);
            
        case "GIFT":
            return await fetchSubmitAddDataDetailStockOpnameGift(setState, body, setError);
            
        case "OTHER_ITEM":
            return await fetchSubmitAddDataDetailStockOpnameOtherItem(setState, body, setError);

        default:
            break;
    }
}

const fetchSubmitAddDataDetailStockOpnameUnit = async (setState, body, setError) => {
    let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").submitAddDataDetailUnit,
        menuName: "Stock Opname",
        setError: setError,
        args: body,
    });
    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
        setState((prevValue) => ({
            ...prevValue,
            dataTable: response.data.data.map(item => ({
                dataVariant: {
                    kodeVariant: item.variantReponseDTO.kodeVariant,
                    namaVariant: item.variantReponseDTO.namaVariant
                },
                dataWarna: {
                    kodeWarna: item.warnaDTO.kodeWarna,
                    namaWarnaKomersil: item.warnaDTO.namaWarnaKomersil,
                    namaWarnaPabrik: item.warnaDTO.namaWarnaPabrik,
                },
                engineNumberEncrypted: item.engineNumberEncrypted,
                noSin: item.engineNumber,
                noKa: item.nomorRangka,
            })),
            dataForSubmitted: response.data.data,
            totalProcess: {
                ...prevValue.totalProcess,
                totalItem: response.data.data.length,
                totalScanned: response.data.data.filter((item) => item.unitExist === true).length,
                totalUnScanned: response.data.data.filter((item) => item.unitExist === false).length
            },
        }));
    }
}

const fetchSubmitAddDataDetailStockOpnameKSU = async (setState, body, setError) => {
    let response = await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").submitAddDataDetailKSU,
        menuName: "Stock Opname",
        setError: setError,
        args: body,
    });
    if (response.ok && response.data.status === HttpStatus.SUCCESS) {
        setState((prevValue) => ({
            ...prevValue,
            dataTable: response.data.data.map(item => ({
                ...item,
                ksuBarcode: item.qrCode,
                ksuBarcodeEncrypted: item.qrCodeEncrypted,
            })),
            dataForSubmitted: response.data.data,
            totalProcess: {
                ...prevValue.totalProcess,
                totalItem: response.data.data.length,
                totalScanned: response.data.data.filter((item) => item.ksuExist === true).length,
                totalUnScanned: response.data.data.filter((item) => item.ksuExist === false).length
            },
        }));
    }
}

const fetchSubmitAddDataDetailStockOpnameGift = async (
  setState,
  body,
  setError,
  rawDetailData,
  activityType
) => {

  let response = await fetchDataAsync({
    asyncFn: Api.create("NAGAMAS_TRANSACTION").getGiftForStockOpname,
    menuName: "Stock Opname",
    setError,
    args: body,
  });

  if (!(response.ok && response.data.status === HttpStatus.SUCCESS)) return;

  const data = response.data.data || {};
  const qrList = data?.giftQr || [];
  const nonQrList = data?.giftNonQr || [];

  setState(prev => {
    const initialTempQR =
      prev.tempDataTable.length === 0
        ? (activityType === "UPDATE"
            ? (rawDetailData?.giftQr || [])
            : [])
        : prev.tempDataTable;

    const initialTempNonQR =
      prev.tempDataTableNonQr.length === 0
        ? (activityType === "UPDATE"
            ? (rawDetailData?.giftNonQr || [])
            : [])
        : prev.tempDataTableNonQr;

    const isSameQR = (a, b) =>
      a.kodeHadiah === b.kodeHadiah &&
      a.giftBarcode === b.giftBarcode;

    const isSameNonQR = (a, b) =>
      a.kodeHadiah === b.kodeHadiah;

    const mappedQR = qrList.map(item => ({
      ...item,
      namaHadiah: item?.giftCode?.nameHadiah,
      kodeHadiah: item?.giftCode?.kodeHadiah,
      categoryHadiah: item?.giftCode?.categoryDTO.value,
      satuan: item?.giftCode?.satuanDTO?.value,
      satuanKey: item?.giftCode?.satuanDTO?.key,
      giftBarcode: item?.giftBarcode,
      barcodeEncrypted: item?.barcodeEncrypted,
      qty: item?.giftCode?.qty || 0,
      actualQty: 0,
      diffQty: 0,
      note: "",
      exist: false
    }));

    const mappedNonQR = nonQrList.map(item => ({
      ...item,
      actQTY: 0,
      diffQty: 0,
      keterangan: null,
      namaHadiah: item.giftCode?.nameHadiah,
      kodeHadiah: item.giftCode?.kodeHadiah,
      categoryHadiah: item?.giftCode?.categoryDTO.value,
      satuan: item.giftCode?.satuanDTO?.value,
      satuanKey: item.giftCode?.satuanDTO?.key,
      isSaved: true
    }));

    const mergedTempQR = [
      ...initialTempQR,
      ...mappedQR.filter(
        newItem => !initialTempQR.some(oldItem => isSameQR(oldItem, newItem))
      )
    ];

    const mergedTempNonQR = [
      ...initialTempNonQR,
      ...mappedNonQR.filter(
        newItem => !initialTempNonQR.some(oldItem => isSameNonQR(oldItem, newItem))
      )
    ];

    const mergedDataTable = [
      ...prev.dataTable,
      ...mappedQR.filter(
        newItem => !prev.dataTable.some(oldItem => isSameQR(oldItem, newItem))
      )
    ];

    const mergedDataTableNonQR = [
      ...prev.dataTableNonQr,
      ...mappedNonQR.filter(
        newItem => !prev.dataTableNonQr.some(oldItem => isSameNonQR(oldItem, newItem))
      )
    ];

    const validQRKey = new Set(
      mappedQR.map(i => i.kodeHadiah + "|" + i.giftBarcode)
    );
    
    const validNonQRKey = new Set(
      mappedNonQR.map(i => i.kodeHadiah)
    );

    const cleanedDataTable = mergedDataTable.filter(i =>
      validQRKey.has(i.kodeHadiah + "|" + i.giftBarcode)
    );
    
    const cleanedDataTableNonQR = mergedDataTableNonQR.filter(i =>
      validNonQRKey.has(i.kodeHadiah)
    );

    return {
      ...prev,

      tempDataTable: mergedTempQR,
      tempDataTableNonQr: mergedTempNonQR,

      dataTable: cleanedDataTable,
      dataTableNonQr: cleanedDataTableNonQR,

      dataForSubmitted: data,

      // totalProcess: {
      //   totalItem: mergedDataTable.length,
      //   totalScanned: mergedDataTable.length,
      //   totalUnScanned: 0,
      // },

      totalProcess: {
        ...prev.totalProcess,
        totalItem: 0,
        totalScanned: 0,
        totalUnScanned: 0,
      },

      totalProcessNonQr: {
        totalItem: mergedDataTableNonQR.length,
        totalScanned: mergedDataTableNonQR.length,
        totalUnScanned: 0,
      }
    };
  });
};

const fetchSubmitAddDataDetailStockOpnamePart = async (
  setState,
  body,
  setError,
  rawDetailData,
  activityType
) => {
  let response = await fetchDataAsync({
    asyncFn: Api.create("NAGAMAS_TRANSACTION").getPartForStockOpname,
    menuName: "Stock Opname",
    setError,
    args: body,
  });

  if (!(response.ok && response.data.status === HttpStatus.SUCCESS)) return;

  const data = response.data.data || {};
  const partQrList = data.partQrList || [];
  const partNonQrList = data.partNonQrList || [];

  setState(prev => {
    const initialTempQR =
      prev.tempDataTable.length === 0
        ? (activityType === "UPDATE" ? (rawDetailData?.partQrList || []) : [])
        : prev.tempDataTable;

    const initialTempNonQR =
      prev.tempDataTableNonQr.length === 0
        ? (activityType === "UPDATE" ? (rawDetailData?.partNonQrList || []) : [])
        : prev.tempDataTableNonQr;

    const isSameQR = (a, b) =>
      a.category === b.category &&
      a.kodePart === b.kodePart;

    const isSameNonQR = (a, b) =>
      a.category === b.category &&
      a.kodePart === b.kodePart;

    const mappedQR = partQrList?.map(item => ({
      ...item,
      kodePart: item.kodePart?.kodePart,
      partName: item.kodePart?.partName,
      category: item.kodePart?.partCategory?.value,
      satuan: item.kodePart?.satuan?.value,
      qrCode: item.partBarcode,
      barcodeEncrypted: item.barcodeEncrypted,
      qty: item.quantity ?? 0,
      actualQty: 0,
      diffQty: 0,
      note: "",
      userName: "-",
      exist: false,
      kodeCabang: item.kodeCabang,
      kodeLocation: item.kodeLocation,
    }));

    const mappedNonQR = partNonQrList.map(item => ({
      ...item,
      kodePart: item.partCode?.kodePart,
      partName: item.partCode?.partName,
      category: item.partCode?.partCategory?.value,
      satuan: item.partCode?.satuan?.value,
      qty: item.quantity ?? 0,
      actualQty: null,
      diffQty: null,
      keterangan: null,
      isSaved: true,
      userName: "-",
      exist: false,
      kodeCabang: item.kodeCabang,
      kodeLocation: item.kodeLocation,
    }));

    const mergedTempQR = [
      ...initialTempQR,
      ...mappedQR.filter(
        newItem => !initialTempQR.some(oldItem => isSameQR(oldItem, newItem))
      )
    ];

    const mergedTempNonQR = [
      ...initialTempNonQR,
      ...mappedNonQR.filter(
        newItem => !initialTempNonQR.some(oldItem => isSameNonQR(oldItem, newItem))
      )
    ];

    const mergedDataTable = [
      ...prev.dataTable,
      ...mappedQR.filter(
        newItem => !prev.dataTable.some(oldItem => isSameQR(oldItem, newItem))
      )
    ];

    const mergedDataTableNonQr = [
      ...prev.dataTableNonQr,
      ...mappedNonQR.filter(
        newItem => !prev.dataTableNonQr.some(oldItem => isSameNonQR(oldItem, newItem))
      )
    ];

    const validQR = new Set(mappedQR.map(i => i.kodePart + "|" + i.category));
    const validNonQR = new Set(mappedNonQR.map(i => i.kodePart + "|" + i.category));

    const cleanedDataTable = mergedDataTable.filter(i =>
      validQR.has(i.kodePart + "|" + i.category)
    );

    const cleanedDataTableNonQr = mergedDataTableNonQr.filter(i =>
      validNonQR.has(i.kodePart + "|" + i.category)
    );

    return {
      ...prev,

      tempDataTable: mergedTempQR,
      tempDataTableNonQr: mergedTempNonQR,
      dataTable: cleanedDataTable,
      dataTableNonQr: cleanedDataTableNonQr,

      dataForSubmitted: data,

      totalProcess: {
        ...prev.totalProcess,
        totalItem: 0,
        totalScanned: 0,
        totalUnScanned: 0,
      },
    };
});

};

const fetchSubmitAddDataDetailStockOpnameOtherItem = async (
  setState,
  body,
  setError,
  rawDetailData,
  activityType
) => {

  let response = await fetchDataAsync({
    asyncFn: Api.create("NAGAMAS_TRANSACTION").getOtherItemForStockOpname,
    menuName: "Stock Opname",
    setError,
    args: {
      kodeCabang: body?.kodeCabang,
      kodeLocator: body?.kodeLocation,
      otherItemCode: body?.otherItemCode
    },
  });

  if (!(response.ok && response.data.status === HttpStatus.SUCCESS)) return;

  const data = response.data.data || {};
  const qrList = data.dataOtherItemBarcode || [];
  const nonQrList = data.dataOtherItem || [];

  setState(prev => {
    const initialTempQR =
      prev.tempDataTable.length === 0
        ? (activityType === "UPDATE"
            ? (rawDetailData?.dataOtherItemBarcode || [])
            : [])
        : prev.tempDataTable;

    const initialTempNonQR =
      prev.tempDataTableNonQr.length === 0
        ? (activityType === "UPDATE"
            ? (rawDetailData?.dataOtherItem || [])
            : [])
        : prev.tempDataTableNonQr;

    // Identifikasi item sama
    const isSameQR = (a, b) =>
      a.kodeOtherItem === b.kodeOtherItem &&
      a.barcode === b.barcode;

    const isSameNonQR = (a, b) =>
      a.kodeOtherItem === b.kodeOtherItem;

    // Mapping QR
    const mappedQR = qrList.map(item => ({
      ...item,
      namaOtherItem: item?.dataOtherItem?.nameotheritem,
      kodeOtherItem: item?.dataOtherItem?.kodeotheritem,
      categoryotheritem: item?.dataOtherItem?.categoryDTO.value,
      satuan: item?.dataOtherItem?.satuanDTO?.value,
      satuanKey: item?.dataOtherItem?.satuanDTO?.key,
      barcode: item?.barcode,
      barcodeEncrypted: item?.barcodeEncrypted,
      qty: item?.dataOtherItem?.qty || 0,
      actualQty: 0,
      diffQty: 0,
      note: "",
      exist: false
    }));

    // Mapping Non QR
    const mappedNonQR = nonQrList.map(item => ({
      ...item,
      actQTY: 0,
      diffQty: 0,
      keterangan: null,
      namaOtherItem: item.dataOtherItem.nameotheritem,
      kodeOtherItem: item.dataOtherItem.kodeotheritem,
      categoryotheritem: item?.dataOtherItem?.categoryDTO.value,
      satuan: item.dataOtherItem.satuanDTO?.value,
      satuanKey: item.dataOtherItem.satuanDTO?.key,
      isSaved: true
    }));

    // const mergedDataTable = mappedQR;
    // const mergedDataTableNonQR = mappedNonQR;

    // const mergedTempQR = mappedQR;
    // const mergedTempNonQR = mappedNonQR;

    // MERGE tempDataTable (QR)
    const mergedTempQR = [
      ...initialTempQR,
      ...mappedQR.filter(
        newItem => !initialTempQR.some(oldItem => isSameQR(oldItem, newItem))
      )
    ];

    // MERGE tempDataTableNonQr
    const mergedTempNonQR = [
      ...initialTempNonQR,
      ...mappedNonQR.filter(
        newItem => !initialTempNonQR.some(oldItem => isSameNonQR(oldItem, newItem))
      )
    ];

    // Merge ke dataTable 
    const mergedDataTable = [
      ...prev.dataTable,
      ...mappedQR.filter(
        newItem => !prev.dataTable.some(oldItem => isSameQR(oldItem, newItem))
      )
    ];

    // Merge ke dataTableNonQr
    const mergedDataTableNonQR = [
      ...prev.dataTableNonQr,
      ...mappedNonQR.filter(
        newItem => !prev.dataTableNonQr.some(oldItem => isSameNonQR(oldItem, newItem))
      )
    ];

    const validQRKey = new Set(
      mappedQR.map(i => i.kodeOtherItem + "|" + i.barcode)
    );

    const validNonQRKey = new Set(
      mappedNonQR.map(i => i.kodeOtherItem)
    );

    const cleanedDataTable = mergedDataTable.filter(i =>
      validQRKey.has(i.kodeOtherItem + "|" + i.barcode)
    );

    const cleanedDataTableNonQR = mergedDataTableNonQR.filter(i =>
      validNonQRKey.has(i.kodeOtherItem)
    );

    return {
      ...prev,

      tempDataTable: mergedTempQR,
      tempDataTableNonQr: mergedTempNonQR,

      dataTable: cleanedDataTable,
      dataTableNonQr: cleanedDataTableNonQR,

      dataForSubmitted: data,

      // totalProcess: {
      //   totalItem: mergedDataTable.length,
      //   totalScanned: 0,
      //   totalUnScanned: 0,
      // },

      totalProcess: {
        ...prev.totalProcess,
        totalItem: 0,
        totalScanned: 0,
        totalUnScanned: 0,
      },

      totalProcessNonQr: {
        totalItem: mergedDataTableNonQR.length,
        totalScanned: mergedDataTableNonQR.length,
        totalUnScanned: 0,
      }
    };
  });
};


export const fetchSubmitProcessStockOpname = async (type, body, setError) => {
    let valueType = Object.keys(type).length > 0 ? type.value : null;
    switch (valueType) {
        case "UNIT":
            return await fetchSubmitProcessStockOpnameUnit(body, setError);

        case "PART":
            return await fetchSubmitProcessStockOpnamePart(body, setError);

        case "KSU":
            return await fetchSubmitProcessStockOpnameKSU(body, setError);
            
        case "GIFT":
            return await fetchSubmitProcessStockOpnameGift(body, setError);
            
        case "OTHER_ITEM":
            return await fetchSubmitProcessStockOpnameOtherItem(body, setError);
        
        default:
            break;
    }
}

const fetchSubmitProcessStockOpnameUnit = async (body, setError) => {
    return await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").submitProcessStockOpnameUnit,
        menuName: "Stock Opname Unit",
        setError: setError,
        args: body,
    });
}

const fetchSubmitProcessStockOpnameKSU = async (body, setError) => {
    return await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").submitProcessStockOpnameKSU,
        menuName: "Stock Opname KSU",
        setError: setError,
        args: body,
    });
}

const fetchSubmitProcessStockOpnameGift = async (body, setError) => {
    return await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").submitProcessStockOpnameGIFT,
        menuName: "Stock Opname Gift",
        setError: setError,
        args: body,
    });
}

const fetchSubmitProcessStockOpnamePart = async (body, setError) => {
    return await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").submitProcessStockOpnamePart,
        menuName: "Stock Opname Part",
        setError: setError,
        args: body,
    });
}

const fetchSubmitProcessStockOpnameOtherItem = async (body, setError) => {
    return await fetchDataAsync({
        asyncFn: Api.create("NAGAMAS_TRANSACTION").submitProcessStockOpnameOtherItem,
        menuName: "Stock Opname Part",
        setError: setError,
        args: body,
    });
}

// TO DO: fetch data check box
export const fetchDataCheckBox = async (setState, type) => {
    let valueType = Object.keys(type).length > 0 ? type.value : null;
    switch (valueType) {
        case "UNIT":
            return await fetchDataType(setState);

        case "PART":
            return await fetchDataPart(setState)

        case "KSU":
            return await fetchDataKSU(setState);

        case "GIFT":
            return await fetchDataGift(setState)
            
        case "OTHER_ITEM":
            return await fetchDataOtherItem(setState)

        default:
            break;
    }
}

const fetchDataType = async (setState) => {
    try {
        let response = await Api.create("NAGAMAS_MASTER_DATA").getAllType();
        if (response.ok) {
            setState((prevState) => ({
                ...prevState,
                dataCheckBox: response.data.data.map(item => {
                    return {
                        id: item.id,
                        name: item.typeName,
                    }
                }),
            }));
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

const fetchDataKSU = async (setState) => {
    try {
        let response = await Api.create("NAGAMAS_MASTER_DATA").getAllKSU();
        if (response.ok) {
            setState((prevState) => ({
                ...prevState,
                dataCheckBox: response.data.data.map(item => {
                    return {
                        id: item.kodeKSU,
                        name: item.name,
                    }
                }),
            }));
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

const fetchDataGift = async (setState) => {
    try {
        let response = await Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
            paramFilters: {
                bizparCategory: "GIFT_TYPE",
                status: "ACTIVE"
            }
        });
        if (response.ok) {
            setState((prevState) => ({
                ...prevState,
                dataCheckBox: response.data.data.map(item => {
                    return {
                        id: item.key,
                        name: item.value,
                    }
                }),
            }));
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

const fetchDataPart = async (setState) => {
    try {
        let response = await Api.create("NAGAMAS_MASTER_DATA").getAllBizpar({
            paramFilters: {
                bizparCategory: "PART_TYPE",
                status: "ACTIVE"
            }
        });
        if (response.ok) {
            setState((prevState) => ({
                ...prevState,
                dataCheckBox: response.data.data.map(item => {
                    return {
                        id: item.key,
                        name: item.value,
                    }
                }),
            }));
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

const fetchDataOtherItem = async (setState) => {
    try {
        let response = await Api.create(
          "NAGAMAS_MASTER_DATA"
        ).getAllOtherItemPagingByParam({
          paramFilters: {},
          limit: null,
          page: null,
        });
        if (response.ok) {
            setState((prevState) => ({
                ...prevState,
                dataCheckBox: response.data.data.map(item => {
                    return {
                        id: item.kodeotheritem,
                        name: item.categoryotheritem,
                    }
                }),
            }));
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

// Other Utils
const convertDateFormat = (dateStr) => {
    return dateStr.replace(/\//g, "-");
}

export const constructRequestBodySubmitAddData = (type, controls, list) => {
    let requestBody = {
        kodeCabang: controls.kodeCabang?.value?.value,
        kodeLocation: controls.kodeLocation?.value?.value,
    }

    let valueType = Object.keys(type).length > 0 ? type.value : null;
    switch (valueType) {
        case "UNIT": {
            requestBody["listIdTypes"] = list
            return requestBody;
        }

        case "PART":
            requestBody["categoryPartCodes"] = list
            return requestBody;

        case "KSU": {
            requestBody["listKodeKSU"] = list
            return requestBody;
        }

        case "GIFT":
            requestBody["giftCategories"] = list
            return requestBody;

        case "OTHER_ITEM":
            requestBody["otherItemCode"] = list
            return requestBody

        default:
            break;
    }
}

export const constructRequestBodySubmitProcess = (props, list, idUser) => {
    let type = props.controls.stockOpnameType.value;
    let valueType = Object.keys(type).length > 0 ? type.value : null;
    let controls = props.controls;
    let isProcess = props.isProcess;
    const formGroup = flattenFormGroupObject(controls);
    
    let stockOpnameDTO = {
        ...formGroup,
        noStockOpname: R.equals(props.activityType, ACTIVITY_TYPE.CREATE) && R.isNil(isProcess) ? null : formGroup.noStockOpname,
        stockOpnameDate: formGroup.stockOpnameDate ? convertDateFormat(formGroup.stockOpnameDate) : null,
        stockOpnameType: getValueFromDDL(formGroup, "stockOpnameType"),
        kodeCabang: getValueFromDDL(formGroup, "kodeCabang"),
        kodeLocation: getValueFromDDL(formGroup, "kodeLocation"),
        stockOpnameStatus: isProcess ? "SUBMITTED" : "DRAFT",
    }

    const dtoKey = valueType === "OTHER_ITEM" ? "dataHeaderSO" : "stockOpnameDTO"

    let requestBody = {
        [dtoKey]: stockOpnameDTO,
        ...constructRequestBodyDetailSubmitProcess(valueType, list, isProcess, formGroup, idUser),
    }

    return requestBody;
}

const constructRequestBodyDetailSubmitProcess = (type, list, isProcess, formGroup, idUser) => {
    console.log(list);
    
    switch (type) {
        case "UNIT": {
            return {
                listStockOpnameUnitDTO: list?.map(item => {
                    return {
                        stockOpnameUnitId: item.stockOpnameUnitId,
                        engineNumber: item.noSin,
                        kodeVarian: item.dataVariant.kodeVariant,
                        kodeWarna: item.dataWarna.kodeWarna,
                        engineNumberEncrypted: item.noSinBarcodeEncrypted,
                        unitExist: item.unitExist,
                        userId: item?.userId || null,
                    };
                })
            }
        }

        case "PART":
            return {
              listStockOpnamePartDTO: list.nonQr.map((item) => ({
                stockOpnamePartId: item?.stockOpnamePartId || null,
                stockOpnameNo: item?.stockOpnameNo || formGroup?.noStockOpname,
                partCode: item?.kodePart,
                qty: parseInt(item?.qty) || 0,
                actualQty: parseInt(item?.actualQty) || 0,
                diffQty: item?.diffQty || 0,
                note: item?.note,
                userId: item?.userId || null,
              })),
              listStockOpnamePartQrDTO: list.qr.map((item) => ({
                stockOpnamePartQrid: item?.stockOpnamePartQrid || null,
                stockOpnameNo: item?.stockOpnameNo || formGroup?.noStockOpname,
                partCode: item?.kodePart,
                partBarcode: item?.partBarcode,
                // partExist: isProcess ? item?.partExist : item?.exist,
                partExist: item?.partExist || false,
                userId: item?.userId || null,
              })),
            };

        case "KSU": {
            return {
                listStockOpnameKSUDTO: list?.map(item => {
                    return {
                        stockOpnameKsuId: item.stockOpnameKsuId,
                        ksuBarcode: item.ksuBarcode,
                        ksuBarcodeEncrypted: item.ksuBarcodeEncrypted === null ? item?.qrCodeEncrypted : item?.ksuBarcodeEncrypted,
                        kodeKsu: item.dataMasterKSU.kodeKSU,
                        ksuExist: item.ksuExist,
                        satuan: item.dataMasterKSU?.satuanDTO?.key,
                        userId: item?.userId || null,
                    };
                })
            }
        }

        case "GIFT":
            return {
              listNonQr: list.nonQr.map((item) => ({
                stockOpnameGiftId: item?.stockOpnameGiftId || null,
                giftCode: item?.kodeHadiah,
                qty: item?.qty || 0,
                actualQty: item?.actQTY || 0,
                diffQty: item?.diffQty || 0,
                note: item?.keterangan,
                userId: item?.userId || null,
              })),
              listQr: list.qr.map((item) => ({
                stockOpnameGiftQrId: item?.stockOpnameGiftQrId || null,
                giftCode: item?.kodeHadiah,
                giftBarcode: item?.giftBarcode,
                giftExist: item?.giftExist || false,
                userId: item?.userId || null,
              })),
            };

        case "OTHER_ITEM":
            return {
              listOtherItem: list.nonQr.map((item) => ({
                id: item.id,
                otherItemCode: item?.otherItemCode || item?.kodeOtherItem,
                qty: item.qty,
                actualQty: item.actualQty,
                diffQty: item.diffQty,
                note: item.note,
                userId: item?.userId || null,
              })),
              listOtherItemBarcode: list.qr.map((item) => ({
                id: item.id,
                otherItemCode: item?.otherItemCode || item?.kodeOtherItem,
                barcode: item.barcode,
                exist: item.exist || false,
                userId: item?.userId || null,
              })),
            };

        default:
            break;
    }
}

export const parseBarcodeData = (data) => {
    if (!data) return null;

    try {
        const boundingBox = {
            x: data[0].boundingBox?.x || 0,
            y: data[0].boundingBox?.y || 0,
            width: data[0].boundingBox?.width || 0,
            height: data[0].boundingBox?.height || 0,
        };

        const cornerPoints = Array.isArray(data[0].cornerPoints)
            ? data[0].cornerPoints.map((point) => ({
                x: (point && point.x) || 0,
                y: (point && point.y) || 0,
            }))
            : [];

        const parsedBarcode = {
            boundingBox,
            cornerPoints,
            format: data[0].format || '',
            rawValue: data[0].rawValue || '',
        };

        return parsedBarcode;
    } catch (error) {
        console.error("Error parsing barcode data:", error);
        return null;
    }
}

export const constructGenSeqPayload = (kodeCabang) => {
    return {
        seqType: GenericSequenceType.STOCK_OPNAME,
        nosDealerCode: kodeCabang.value,
        transactionType: GenericSequenceType.STOCK_OPNAME,
    }
}

export const fetchReportSO = async (setState, type, queryParam) => {
    let valueType = Object.keys(type).length > 0 ? type.value : null;
    switch (valueType) {
        case "UNIT":
            return await fetchReportSOUnitKSU(setState, queryParam);

        case "PART":
            return await fetchReportSOPart(setState, queryParam);

        case "KSU":
            return await fetchReportSOUnitKSU(setState, queryParam);

        case "GIFT":
            return await fetchReportSOGift(setState, queryParam);

        case "OTHER_ITEM":
            return await fetchReportSOOtherItem(setState, queryParam);

        default:
            break;
    }
}

const fetchReportSOUnitKSU = async (setState, queryParam) => {
    try {
        let response = await Api.create("NAGAMAS_TRANSACTION").reportSO(queryParam)
        if (response.ok) {
            setState((prevValue) => ({
                ...prevValue,
                reportSO: {
                    ...prevValue.reportSO,
                    listDataQR: response?.data?.data?.listDataQR || [],
                    listDataTanpaQR: response?.data?.data?.listDataTanpaQR || []
                }
            }))
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

const fetchReportSOGift = async (setState, queryParam) => {
    try {
        let response = await Api.create("NAGAMAS_TRANSACTION").reportSO(queryParam)
        if (response.ok) {
            setState((prevValue) => ({
                ...prevValue,
                reportSO: {
                    ...prevValue.reportSO,
                    listDataQR: response?.data?.data?.listDataQR || [],
                    listDataTanpaQR: response?.data?.data?.listDataTanpaQR || []
                }
            }))
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

const fetchReportSOPart = async (setState, queryParam) => {
    try {
        let response = await Api.create("NAGAMAS_TRANSACTION").reportSO(queryParam);
        console.log("REPORT SO RESPONSE:", response);

        if (response.ok) {
            setState(prevValue => ({
                ...prevValue,
                reportSO: {
                    ...prevValue.reportSO,
                    listDataQR: response?.data?.data?.listDataQR || [],
                    listDataTanpaQR: response?.data?.data?.listDataTanpaQR || []
                }
            }));
        }
    } catch (error) {
        console.log("errors: ", error);
    }
};


const fetchReportSOOtherItem = async (setState, queryParam) => {
    try {
        let response = await Api.create("NAGAMAS_TRANSACTION").reportSO(queryParam)
        if (response.ok) {
            setState((prevValue) => ({
                ...prevValue,
                reportSO: {
                    ...prevValue.reportSO,
                    listDataQR: response?.data?.data?.listDataQR || [],
                    listDataTanpaQR: response?.data?.data?.listDataTanpaQR || []
                }
            }))
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}


export const fetchKelebihanSO = async (setState, type, queryParam) => {
    let valueType = Object.keys(type).length > 0 ? type.value : null;
    switch (valueType) {
        case "UNIT":
            return await fetchKelebihanSOUnitKSU(setState, queryParam);

        case "PART":
            return await fetchKelebihanSOPart(setState, queryParam);

        case "KSU":
            return await fetchKelebihanSOUnitKSU(setState, queryParam);

        case "GIFT":
            return await fetchKelebihanSOGift(setState, queryParam);

        case "OTHER_ITEM":
            return await fetchKelebihanSOOtherItem(setState, queryParam);

        default:
            break;
    }
}

const fetchKelebihanSOUnitKSU = async (setState, queryParam) => {
    try {
        let response = await Api.create("NAGAMAS_TRANSACTION").dataKelebihanSO(queryParam)
        if (response.ok) {
            setState((prevValue) => ({
                ...prevValue,
                dataKelebihan: {
                    ...prevValue.dataKelebihan,
                    listDataQR: response.data.data.listDataQR || "",
                    listDataTanpaQR: response.data.data.listDataTanpaQR || [],
                    edit: !isNullOrEmpty(response.data.data.listDataQR),
                }
            }))
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

const fetchKelebihanSOPart = async (setState, queryParam) => {
    try {
        let response = await Api.create("NAGAMAS_TRANSACTION").dataKelebihanSO(queryParam)
        
        if (response.ok) {
            setState((prevValue) => ({
                ...prevValue,
                dataKelebihan: {
                    ...prevValue.dataKelebihan,
                    listDataQR: response.data?.data?.listDataQR || "",
                    listDataTanpaQR: response.data?.data?.listDataTanpaQR || [],
                    edit: !isNullOrEmpty(response.data?.data?.listDataQR),
                }
            }))
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

const fetchKelebihanSOGift = async (setState, queryParam) => {
    try {
        let response = await Api.create("NAGAMAS_TRANSACTION").dataKelebihanSO(queryParam)
        if (response.ok) {
            setState((prevValue) => ({
                ...prevValue,
                dataKelebihan: {
                    ...prevValue.dataKelebihan,
                    listDataQR: response.data?.data?.listDataQR || "",
                    listDataTanpaQR: response.data?.data?.listDataTanpaQR || [],
                    edit: !isNullOrEmpty(response.data?.data?.listDataQR),
                }
            }))
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

const fetchKelebihanSOOtherItem = async (setState, queryParam) => {
    try {
        let response = await Api.create("NAGAMAS_TRANSACTION").dataKelebihanSO(queryParam)
        if (response.ok) {
            setState((prevValue) => ({
                ...prevValue,
                dataKelebihan: {
                    ...prevValue.dataKelebihan,
                    listDataQR: response.data?.data?.listDataQR || "",
                    listDataTanpaQR: response.data?.data?.listDataTanpaQR || [],
                    edit: !isNullOrEmpty(response.data?.data?.listDataQR),
                }
            }))
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

export const fetchKekuranganSO = async (setState, type, queryParam) => {
    let valueType = Object.keys(type).length > 0 ? type.value : null;
    switch (valueType) {
        case "UNIT":
            return await fetchKekuranganSOUnitKSU(setState, queryParam);

        case "PART":
            return await fetchKekuranganSOPart(setState, queryParam);
            break;

        case "KSU":
            return await fetchKekuranganSOUnitKSU(setState, queryParam);

        case "GIFT":
            return await fetchKekuranganSOGift(setState, queryParam);

        case "OTHER_ITEM":
             return await fetchKekuranganSOOtherItem(setState, queryParam);

        default:
            break
    }
}

const fetchKekuranganSOUnitKSU = async (setState, queryParam) => {
    try {
        let response = await Api.create("NAGAMAS_TRANSACTION").dataKekuranganSO(queryParam)
        if (response.ok) {
            setState((prevValue) => ({
                ...prevValue,
                dataKekurangan: {
                    ...prevValue.dataKekurangan,
                    listDataQR: response.data?.data?.dataDetail.map((val, idx) => {
                            return {
                                ...val,
                                nilaiBeliDiakui: parseFloat(val.nilaiBeliDiakui) || 0,
                                nilaiDibebankanKaryawan: parseFloat(val.nilaiDibebankanKaryawan) || 0,
                                nilaiDibebankanPerusahaan: parseFloat(val.nilaiDibebankanPerusahaan) || 0,
                                exclude: val.exclude || false
                            }
                        })
                        || [],
                    totalDibebankanKaryawanQR: response.data?.data?.dataDetail.reduce((total, item) => {
                        return total + (item.nilaiDibebankanKaryawan || 0)
                    }, 0),
                    totalDibebankanPerusahaanQR: response.data?.data?.dataDetail.reduce((total, item) => {
                        return total + (item.nilaiDibebankanPerusahaan || 0)
                    }, 0),
                    totalQR: response.data?.data?.dataDetail.reduce((total, item) => {
                        return total + (item.nilaiDibebankanPerusahaan || 0) + (item.nilaiDibebankanKaryawan || 0)
                    }, 0),
                    totalDibebankanKaryawanTanpaQR: response.data?.data?.dataDetail.reduce((total, item) => {
                        return total + (item.nilaiDibebankanKaryawan || 0)
                    }, 0),
                    totalDibebankanPerusahaanTanpaQR: response.data?.data?.dataDetail.reduce((total, item) => {
                        return total + (item.nilaiDibebankanPerusahaan || 0)
                    }, 0),
                    totalTanpaQR: response.data?.data?.dataDetail.reduce((total, item) => {
                        return total + (item.nilaiDibebankanPerusahaan || 0) + (item.nilaiDibebankanKaryawan || 0)
                    }, 0),
                    // listDataTanpaQR: response.data.data.listDataTanpaQR || []
                }
            }))
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

const fetchKekuranganSOPart = async (setState, queryParam) => {
    try {
        let response = await Api.create("NAGAMAS_TRANSACTION").dataKekuranganSO(queryParam)
        if (response.ok) {
            setState((prevValue) => ({
                ...prevValue,
                dataKekurangan: {
                    ...prevValue.dataKekurangan,
                    userResolveStockOpname: response.data?.data?.userResolveStockOpname,
                    listDataQR: response.data?.data?.dataDetail?.map((val, idx) => {
                            return {
                                ...val,
                                nilaiBeli: parseFloat(val?.purchaseValue || 0),
                                nilaiBeliDiakui: parseFloat(val.purchaseValueRecognized) || 0,
                                nilaiDibebankanKaryawan: parseFloat(val.employeeResponsibilities) || 0,
                                nilaiDibebankanPerusahaan: parseFloat(val.companyResponsibilities) || 0,
                                exclude: val.exclude || false
                            }
                        })
                        || [],
                    totalDibebankanKaryawanQR: response.data?.data?.dataDetail?.reduce((total, item) => {
                        return total + (item.nilaiDibebankanKaryawan || 0)
                    }, 0),
                    totalDibebankanPerusahaanQR: response.data?.data?.dataDetail?.reduce((total, item) => {
                        return total + (item.nilaiDibebankanPerusahaan || 0)
                    }, 0),
                    totalQR: response.data?.data?.dataDetail?.reduce((total, item) => {
                        return total + (item.nilaiDibebankanPerusahaan || 0) + (item.nilaiDibebankanKaryawan || 0)
                    }, 0),
                    totalDibebankanKaryawanTanpaQR: response.data?.data?.dataDetail?.reduce((total, item) => {
                        return total + (item.nilaiDibebankanKaryawan || 0)
                    }, 0),
                    totalDibebankanPerusahaanTanpaQR: response.data?.data?.dataDetail?.reduce((total, item) => {
                        return total + (item.nilaiDibebankanPerusahaan || 0)
                    }, 0),
                    totalTanpaQR: response.data?.data?.dataDetail?.reduce((total, item) => {
                        return total + (item.nilaiDibebankanPerusahaan || 0) + (item.nilaiDibebankanKaryawan || 0)
                    }, 0),
                    listDataTanpaQR: response.data?.data?.listKekurangan?.map(val=>{
                         return {
                           ...val,
                           nilaiBeli: parseFloat(val?.purchaseValue || 0),
                           nilaiBeliDiakui:
                             parseFloat(val.purchaseValueRecognized) || 0,
                           nilaiDibebankanKaryawan:
                             parseFloat(val.employeeResponsibilities) || 0,
                           nilaiDibebankanPerusahaan:
                             parseFloat(val.companyResponsibilities) || 0,
                           exclude: val.exclude || false,
                         };
                    }) || []
                }
            }))
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

const fetchKekuranganSOGift = async (setState, queryParam) => {
    try {
        let response = await Api.create("NAGAMAS_TRANSACTION").dataKekuranganSO(queryParam)
        if (response.ok) {
            setState((prevValue) => ({
                ...prevValue,
                dataKekurangan: {
                    ...prevValue.dataKekurangan,
                    listDataQR: response.data?.data?.dataDetail?.map((val, idx) => {
                            return {
                                ...val,
                                nilaiBeli: parseFloat(val?.purchaseValue || 0),
                                nilaiBeliDiakui: parseFloat(val.purchaseValueRecognized) || 0,
                                nilaiDibebankanKaryawan: parseFloat(val.employeeResponsibilities) || 0,
                                nilaiDibebankanPerusahaan: parseFloat(val.companyResponsibilities) || 0,
                                exclude: val.exclude || false
                            }
                        })
                        || [],
                    totalDibebankanKaryawanQR: response.data?.data?.dataDetail?.reduce((total, item) => {
                        return total + (item.nilaiDibebankanKaryawan || 0)
                    }, 0),
                    totalDibebankanPerusahaanQR: response.data?.data?.dataDetail?.reduce((total, item) => {
                        return total + (item.nilaiDibebankanPerusahaan || 0)
                    }, 0),
                    totalQR: response.data?.data?.dataDetail?.reduce((total, item) => {
                        return total + (item.nilaiDibebankanPerusahaan || 0) + (item.nilaiDibebankanKaryawan || 0)
                    }, 0),
                    totalDibebankanKaryawanTanpaQR: response.data?.data?.listKekurangan?.reduce((total, item) => {
                        return total + (item.employeeResponsibilities || 0)
                    }, 0),
                    totalDibebankanPerusahaanTanpaQR: response.data?.data?.listKekurangan?.reduce((total, item) => {
                        return total + (item.companyResponsibilities || 0)
                    }, 0),
                    totalTanpaQR: response.data?.data?.listKekurangan?.reduce((total, item) => {
                        return total + (item.companyResponsibilities || 0) + (item.employeeResponsibilities || 0)
                    }, 0),
                    listDataTanpaQR: response.data?.data?.listKekurangan?.map(val=>{
                         return {
                           ...val,
                           nilaiBeli: parseFloat(val?.purchaseValue || 0),
                           nilaiBeliDiakui:
                             parseFloat(val.purchaseValueRecognized) || 0,
                           nilaiDibebankanKaryawan:
                             parseFloat(val.employeeResponsibilities) || 0,
                           nilaiDibebankanPerusahaan:
                             parseFloat(val.companyResponsibilities) || 0,
                           exclude: val.exclude || false,
                         };
                    }) || []
                }
            }))
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

const fetchKekuranganSOOtherItem = async (setState, queryParam) => {
    try {
        let response = await Api.create("NAGAMAS_TRANSACTION").dataKekuranganSO(queryParam)
        if (response.ok) {
            setState((prevValue) => ({
                ...prevValue,
                dataKekurangan: {
                    ...prevValue.dataKekurangan,
                    listDataQR: response.data?.data?.dataDetail?.map((val, idx) => {
                            return {
                                ...val,
                                nilaiBeli: parseFloat(val?.purchaseValue || 0),
                                nilaiBeliDiakui: parseFloat(val.purchaseValueRecognized) || 0,
                                nilaiDibebankanKaryawan: parseFloat(val.employeeResponsibilities) || 0,
                                nilaiDibebankanPerusahaan: parseFloat(val.companyResponsibilities) || 0,
                                exclude: val.exclude || false
                            }
                        })
                        || [],
                    totalDibebankanKaryawanQR: response.data?.data?.dataDetail?.reduce((total, item) => {
                        return total + (item.nilaiDibebankanKaryawan || 0)
                    }, 0),
                    totalDibebankanPerusahaanQR: response.data?.data?.dataDetail?.reduce((total, item) => {
                        return total + (item.nilaiDibebankanPerusahaan || 0)
                    }, 0),
                    totalQR: response.data?.data?.dataDetail?.reduce((total, item) => {
                        return total + (item.nilaiDibebankanPerusahaan || 0) + (item.nilaiDibebankanKaryawan || 0)
                    }, 0),
                    totalDibebankanKaryawanTanpaQR: response.data?.data?.listKekurangan?.reduce((total, item) => {
                        return total + (item.employeeResponsibilities || 0)
                    }, 0),
                    totalDibebankanPerusahaanTanpaQR: response.data?.data?.listKekurangan?.reduce((total, item) => {
                        return total + (item.companyResponsibilities || 0)
                    }, 0),
                    totalTanpaQR: response.data?.data?.listKekurangan?.reduce((total, item) => {
                        return total + (item.companyResponsibilities || 0) + (item.employeeResponsibilities || 0)
                    }, 0),
                    listDataTanpaQR: response.data?.data?.listKekurangan?.map(val=>{
                         return {
                           ...val,
                           nilaiBeli: parseFloat(val?.purchaseValue || 0),
                           nilaiBeliDiakui:
                             parseFloat(val.purchaseValueRecognized) || 0,
                           nilaiDibebankanKaryawan:
                             parseFloat(val.employeeResponsibilities) || 0,
                           nilaiDibebankanPerusahaan:
                             parseFloat(val.companyResponsibilities) || 0,
                           exclude: val.exclude || false,
                         };
                    }) || []
                }
            }))
        }
    } catch (error) {
        console.log("errors: ", error);
    }
}

export const constructSubmitResolvingRequest = (dataDetail, type) => {
    const soDetailIDMap = {
      GIFT: "stockOpnameGiftQrId",
      PART: "stockOpnamePartQrId",
      OTHER_ITEM: "idStockOpname"
    };

    const soDetailID = soDetailIDMap[type] || "stockOpnameDetailId";

    return dataDetail.map((val, idx) => {
        return {
            stockOpnameResolveId: parseInt(val.stockOpnameResolveId) || null,
            stockOpnameDetailId: parseInt(val[soDetailID] || 0),
            nilaiBeliDiakui: parseFloat(val.nilaiBeliDiakui),
            nilaiDibebankanKaryawan: parseFloat(val.nilaiDibebankanKaryawan),
            nilaiDibebankanPerusahaan: parseFloat(val.nilaiDibebankanPerusahaan),
            exclude: val.exclude,
        }
    })
}

// export const constructSubmitResolvingNonQRRequest = (dataDetail, type) => {
//   if (type === "GIFT") {
//     return dataDetail.map((val, idx) => {
//       return {
//         stockOpnamePartResolveId: parseInt(val.stockOpnameResolveId) || null,
//         stockOpnamePartId: parseInt(val.stockOpnameGiftQrId || 0),
//         purchaseValueRecognized: parseFloat(val.nilaiBeliDiakui),
//         employeeResponsibilities: parseFloat(val.nilaiDibebankanKaryawan),
//         companyResponsibilities: parseFloat(val.nilaiDibebankanPerusahaan),
//         exclude: val.exclude,
//       };
//     });
//   } 
//   return [];
// };

export const constructSubmitResolvingNonQRRequest = (dataDetail, type) => {
  const idMap = {
    GIFT: "id",
    PART: "id",
    OTHER_ITEM: "id"
  };

  const idKey = idMap[type];

  if (["GIFT", "OTHER_ITEM", "PART"].includes(type)) {
    const totalPurchaseValueRecognized = dataDetail.reduce((sum, item) => {
      const val = parseFloat(item.nilaiBeliDiakui) || 0;
      return sum + val;
    }, 0);

    return dataDetail.map((val) => ({
      stockOpnamePartResolveId: parseInt(val.stockOpnameResolveId) || null,
      stockOpnamePartId: parseInt(val[idKey] || 0),
      purchaseValueRecognized: parseFloat(val.nilaiBeliDiakui),
       totalPurchaseValueRecognized: totalPurchaseValueRecognized,
      employeeResponsibilities: parseFloat(val.nilaiDibebankanKaryawan),
      companyResponsibilities: parseFloat(val.nilaiDibebankanPerusahaan),
      exclude: val.exclude,
    }));
  }

  return [];
};

export const fetchDataDDLItem = async (setState, type) => {
    switch (type) {
        case "UNIT":
            break

        case "PART":
            return await FetchDataPart();

        case "KSU":
            break

        case "GIFT":
            return await FetchDataGift();

        case "OTHER_ITEM":
            return await FetchDataOtherItem();

        default:
            break
    }
}

const FetchDataPart = async () => {
    try {
        const res = await Api.create("NAGAMAS_MASTER_DATA").getListDataPartByQrCode(false);
        
        return res.data.data?.map(item => ({
            value: item.kodePart,
            label: item.partName,
            partCategory: item.partCategory,
            qty: item.qty,
            satuan: item.satuan,
        }))
    } catch (error) {
        console.log("errors: ", error);
        return null;
    }
}

const FetchDataGift = async () => {
    try {
        const res = await Api.create("NAGAMAS_MASTER_DATA").getAllHadiahPagingByParam({
            paramFilters: {}
        })
        
        return res.data.data?.map(item => ({
            value: item.kodeHadiah,
            label: item.nameHadiah,
            categoryHadiah: item.categoryHadiah,
            qrHadiah: item.qrHadiah,
            satuanHadiah: item.satuanHadiah,
            status: item.status
        }))
    } catch (error) {
        console.log("errors: ", error);
        return null;
    }
}

const FetchDataOtherItem = async () => {
    try {
        let req = {
            paramFilters: {
                qrotheritem: false
            }
        }
        const res = await Api.create("NAGAMAS_MASTER_DATA").getListDropdownOtherItemSO(req)
        
        return res.data.data?.map(item => ({
            value: item.kodeotheritem,
            label: item.nameotheritem,
            categoryDTO: item.categoryotheritem,
            qrotheritem: item.qrotheritem,
            satuanDTO: item.satuanotheritem,
            status: item.status
        }))
    } catch (error) {
        console.log("errors: ", error);
        return null;
    }
}

export const constructListTanpaQR = (rawList = [], type, idUser) => {
  return rawList.map((row) => {
    const item = row.item || {};
    let diffQty = row.diffQty ?? 0;

    if (typeof diffQty === "string") {
      diffQty = parseInt(diffQty.replace("+", ""), 10) || 0;
    }

    const finalDiffQty = row.differenceQty ?? diffQty;
    const finalActualQty = row.physicalQty ?? 0;

    let code = "";
    switch (type) {
      case "PART":
        code = item.kodePart ?? "";
        break;
      case "GIFT":
        code = item.kodeHadiah ?? "";
        break;
      case "OTHER_ITEM":
        code = item.kodeOtherItem ?? item.kodeotheritem ?? "";
        break;
      default:
        code = "";
    }

    console.log(row);
    

    return {
      id: row.id ?? null,
      code,
      qty: row.systemQty ?? item.qty ?? 0,
      actualQty: finalActualQty,
      diffQty: finalDiffQty,
      note: row.notes ?? "",
      userId: idUser ?? ""
    };
  });
};


const mapNonQrByType = (type, item) => {
//   console.log(item);
  
  switch (type) {
    case "PART":
      const part = item.partCode ?? item.item;
      const itemTempPart = {
        ...item,
        qty: item.systemQty ?? item.qty,
        actualQty: item.physicalQty ?? item.actualQty,
        diffQty: item.differenceQty ?? item.diffQty,
        part,
      };

      return {
        kodeItem: itemTempPart?.part?.kodePart,
        namaItem: itemTempPart?.part?.partName,
        groupItem: itemTempPart?.part?.partCategory.value,
        qty: itemTempPart?.qty,
        unit: itemTempPart?.part?.satuan.value,
        actQty: itemTempPart?.actualQty,
        diffQty: itemTempPart?.diffQty,
        status: itemTempPart?.notes ?? itemTempPart?.note ?? "",
        user: itemTempPart?.userId?.name ?? "",
      };

    case "GIFT":
      const gift = item.giftCode ?? item.item;
      const itemTemp = {
        ...item,
        qty: item.systemQty??item.qty,
        actualQty: item.physicalQty??item.actualQty,
        diffQty: item.differenceQty??item.diffQty,
        gift,
      };
      
      return {
        kodeItem: itemTemp?.gift?.kodeHadiah,
        namaItem: itemTemp?.gift?.nameHadiah,
        groupItem: itemTemp?.gift?.categoryDTO.value,
        qty: itemTemp.qty,
        unit: itemTemp?.gift?.satuanDTO.value,
        actQty: itemTemp.actualQty,
        diffQty: itemTemp.diffQty,
        status: itemTemp.notes ?? itemTemp?.note ?? "",
        user: itemTemp.userId?.name ?? "",
      };

    case "OTHER_ITEM":
     const otherItem = item.dataOtherItem ?? item?.item;
     const itemTempOtherItem = {
       ...item,
       qty: item.systemQty ?? item.qty,
       actualQty: item.physicalQty ?? item.actualQty,
       diffQty: item.differenceQty ?? item.diffQty,
       otherItem,
     }; 
     
     return {
       kodeItem: itemTempOtherItem?.otherItem?.kodeotheritem,
       namaItem: itemTempOtherItem?.otherItem?.nameotheritem,
       groupItem: itemTempOtherItem?.otherItem?.categoryDTO.value,
       qty: itemTempOtherItem?.qty,
       unit: itemTempOtherItem?.otherItem?.satuanDTO.value,
       actQty: itemTempOtherItem?.actualQty,
       diffQty: itemTempOtherItem?.diffQty,
       status: itemTempOtherItem?.notes ?? itemTempOtherItem?.note ?? "",
       user: itemTempOtherItem?.userId?.name ?? "",
     };

    default:
      return item;
  }
};

const mapQr = (type, row) => {
  if (!row) return {};
  // console.log(row);
  
  switch (type) {
    case "PART":
      return {
        kodeItem: row.partCode?.kodePart,
        namaItem: row.partCode?.partName,
        groupItem: row.partCode?.partCategory?.value,
        qty: 1,
        unit: row.partCode?.satuan?.value,
        qRcode: row.partBarcode,
        status: row.partExist ? "DITEMUKAN" : "TIDAK DITEMUKAN",
        user: row?.userId?.name ?? "",
      };

    case "GIFT":
      return {
        kodeItem: row.giftCode.kodeHadiah,
        namaItem: row.giftCode.nameHadiah,
        groupItem: row.giftCode.categoryDTO.value,
        qty: 1,
        unit: row.giftCode.satuanDTO.value,
        qRcode: row.giftBarcode,
        status: row.giftExist ? "DITEMUKAN" : "TIDAK DITEMUKAN",
        user: row?.userId?.name ?? "",
      };

    case "OTHER_ITEM":
      return {
        kodeItem: row.dataOtherItem?.kodeotheritem,
        namaItem: row.dataOtherItem?.nameotheritem,
        groupItem: row.dataOtherItem?.categoryDTO.value,
        qty: 1,
        unit: row.dataOtherItem?.satuanDTO.value,
        qRcode: row.barcode ?? row.otherBarcode,
        status: row.exist ? "DITEMUKAN" : "TIDAK DITEMUKAN",
        user: row?.userId?.name ?? "",
      };

    default:
      break
  }
};

const mapSummaryNonQr = (e, soType) => {
  const base = mapNonQrByType(soType, e);

  return {
    ...base,
    // status: "KEKURANGAN",
    buyValue: String(e.nilaiBeli ?? "0"),
    buyAssessment: String(e.nilaiBeliDiakui ?? "0"),
    buyTotal: String(e.totalPurchaseValueRecognized ?? "0"),
    employeeRes: String(e.employeeResponsibilities ?? "0"),
    corpRes: String(e.companyResponsibilities ?? "0"),
    exclude: e.exclude ? "YA" : "TIDAK"
  };
};

const mapSummaryQr = (e, soType) => {
  const base = mapQr(soType, e);

  return {
    ...base,
    buyValue: String(e.nilaiBeli ?? "0"),
    buyAssessment: String(e.nilaiBeliDiakui ?? "0"),
    employeeRes: String(e.employeeResponsibilities ?? "0"),
    corpRes: String(e.companyResponsibilities ?? "0"),
    exclude: e.exclude ? "YA" : "TIDAK"
  };
};

export const buildPayloadByReportType = ({
  pickedReport,
  soType,
  basePayload,
  listNonQr,
  listQr,
  state
}) => {
  const overQr = state.dataKelebihan.listDataQR == "" ? " " : state.dataKelebihan.listDataQR 
  const grandTotal = state.dataKekurangan.totalTanpaQR + state.dataKekurangan.totalQR
  
  const namaDariReportSO =
    state?.reportSO?.listDataQR
      ?.filter(e => e?.userId?.name)
      ?.map(e => e.userId.name) || [];

  const userResolveName =
    state?.dataKekurangan?.userResolveStockOpname?.name || null;

  const listNamaUser = [...namaDariReportSO];

  if (userResolveName) {
    listNamaUser.push(userResolveName);
  }

  switch (pickedReport) {
    case "REPORT_SO":
      return {
        apiFn: Api.create("NAGAMAS_REPORT").printStockOpnameReportSO,
        payload: {
          ...basePayload,
          detailsNonQr: listNonQr.map((e) => mapNonQrByType(soType, e)),
          detailsQr: listQr.map((e) => mapQr(soType, e)),
        },
      };

    case "KELEBIHAN_SO":
      return {
        apiFn: Api.create("NAGAMAS_REPORT").printStockOpnameReportKelebihan,
        payload: {
          ...basePayload,
          overQr,
          overNonQr: state.dataKelebihan.listDataTanpaQR.map((e) => ({
            ...mapNonQrByType(soType, e),
          })),
        },
      };

    case "KEKURANGAN_SO":
      return {
        apiFn: Api.create("NAGAMAS_REPORT").printStockOpnameReportKekurangan,
        payload: {
          ...basePayload,
          detailsNonQr: state.dataKekurangan.listDataTanpaQR.map((e) => mapNonQrByType(soType, e)),
          detailsQr: state.dataKekurangan.listDataQR.map((e) => mapQr(soType, e)),
        },
      };

    case "SUMMARY_SO":
      return {
        apiFn: Api.create("NAGAMAS_REPORT").printStockOpnameReportSummary,
        payload: {
          ...basePayload,
          listNamaUser,
          totalEmpResNonQr: String(state.dataKekurangan.totalDibebankanKaryawanTanpaQR ?? 0),
          totalCoprsResNonQr: String(state.dataKekurangan.totalDibebankanPerusahaanTanpaQR ?? 0),
          totalNonQr: String(state.dataKekurangan.totalTanpaQR ?? 0),
        
          totalEmpResQr: String(state.dataKekurangan.totalDibebankanKaryawanQR ?? 0),
          totalCoprsResQr: String(state.dataKekurangan.totalDibebankanPerusahaanQR ?? 0),
          totalQr: String(state.dataKekurangan.totalQR ?? 0),
          grandTotal: String(grandTotal ?? 0),
        
          detailsNonQr: state.dataKekurangan.listDataTanpaQR.map((e) =>
            mapSummaryNonQr(e, soType)
          ),
          detailsQr: state.dataKekurangan.listDataQR.map((e) =>
            mapSummaryQr(e, soType)
          ),
        },
      };

    default:
      return { apiFn: null, payload: basePayload };
  }
};

export function downloadPdf(blob, fileName) {
    const link = document.createElement("a");
    const url = URL.createObjectURL(blob);
    link.href = url;
    link.download = fileName;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
}
